import type { KatalogEndpunkt } from '../gql/graphql.ts';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Badge,
  Checkbox,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { AttributListe } from './AttributListe.tsx';
import { checkboxZustand } from '../hooks/useKatalogAuswahl.ts';

type EndpunktProps = {
  endpunkt: KatalogEndpunkt;
  gewaehlteAttribute: string[] | undefined;
  onToggle: () => void;
  onAttributToggle: (attributName: string) => void;
};

export function Endpunkt({
  endpunkt,
  gewaehlteAttribute,
  onToggle,
  onAttributToggle,
}: EndpunktProps) {
  const { t } = useTranslation();

  const checked = checkboxZustand(
    gewaehlteAttribute,
    endpunkt.attribute.length,
  );

  return (
    <AccordionItem value={endpunkt.name}>
      <div className="flex items-start justify-between">
        <div className="flex gap-2">
          <Checkbox checked={checked} onCheckedChange={onToggle} />

          <div>
            <div className="flex items-center gap-2">
              <Badge type="pill" variant="secondary" className="px-1">
                {endpunkt.httpMethode}
              </Badge>
              <span className="text-sm font-medium text-neutrals-900">
                {endpunkt.anzeigename}
              </span>
            </div>
            <p className="mt-2 text-xs text-neutrals-700">
              {endpunkt.beschreibung}
            </p>
          </div>
        </div>

        <AccordionTrigger className="flex-none py-0 text-xs font-normal text-neutrals-700">
          {t('domain.e2nApi.neuerZugang.attributeZaehler', {
            gewaehlt: gewaehlteAttribute?.length ?? 0,
            gesamt: endpunkt.attribute.length,
          })}
        </AccordionTrigger>
      </div>

      <AccordionContent className="pt-3 pl-8">
        <AttributListe
          attribute={endpunkt.attribute}
          gewaehlteAttribute={gewaehlteAttribute ?? []}
          infoSeite="right"
          onToggle={onAttributToggle}
        />
      </AccordionContent>
    </AccordionItem>
  );
}
